// Utilitários para manipulação de cartões

// Formatar número do cartão com espaços
export const formatCreditCardNumber = (value: string): string => {
	// Filtra qualquer caractere que não seja número
	const v = value.replace(/[^0-9]/g, "");

	// Limita a 19 dígitos (padrão máximo para cartões)
	const limited = v.slice(0, 19);

	// Adiciona espaços a cada 4 dígitos
	const parts = [];
	for (let i = 0; i < limited.length; i += 4) {
		parts.push(limited.substring(i, i + 4));
	}

	return parts.join(" ");
};

// Formatar data de validade
export const formatExpiryDate = (value: string): string => {
	const v = value.replace(/[^0-9]/g, "");

	if (v.length >= 3) {
		return `${v.substring(0, 2)}/${v.substring(2, 4)}`;
	}

	return v;
};

// Detectar bandeira do cartão
export const detectCardType = (cardNumber: string): string => {
	const regexPattern = {
		MASTERCARD: /^5[1-5][0-9]{14}$|^2(?:2(?:2[1-9]|[3-9][0-9])|[3-6][0-9][0-9]|7(?:[01][0-9]|20))[0-9]{12}$/,
		VISA: /^4[0-9]{12}(?:[0-9]{3})?$/,
		AMEX: /^3[47][0-9]{13}$/,
		ELO: /^((((636368)|(438935)|(504175)|(451416)|(636297))[0-9]{0,10})|((5067)|(4576)|(4011))[0-9]{0,12})$/,
		HIPERCARD: /^(606282\d{10}(\d{3})?)|(3841\d{15})$/,
	};

	for (const card in regexPattern) {
		if (cardNumber.replace(/\s+/g, "").match(regexPattern[card as keyof typeof regexPattern])) {
			return card;
		}
	}
	return "";
};

// Validar número de cartão usando o algoritmo de Luhn (Mod 10)
export const validateCardNumber = (cardNumber: string): boolean => {
	if (!cardNumber) return false;

	// Remove espaços
	const value = cardNumber.replace(/\s+/g, "");

	// Verifica se contém apenas dígitos
	if (!/^\d+$/.test(value)) return false;

	// Verifica o comprimento
	if (value.length < 13 || value.length > 19) return false;

	// Implementação do algoritmo de Luhn (Mod 10)
	let sum = 0;
	let shouldDouble = false;

	// Loop de trás para frente
	for (let i = value.length - 1; i >= 0; i--) {
		let digit = Number.parseInt(value.charAt(i), 10);

		if (shouldDouble) {
			digit *= 2;
			if (digit > 9) digit -= 9;
		}

		sum += digit;
		shouldDouble = !shouldDouble;
	}

	return sum % 10 === 0;
};
